'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Html = require('base/Colido.Html');
var ItemView = require('base/Colido.ItemView');
var SubscriptionModalLayout = require('modules/settings/views/layout/subscription/modal');
var VoucherModalView = require('../../layout/subscription/voucher-modal');

var templateDisplay = require('modules/settings/templates/partials/subscription/plan-display.hbs');
var templateEdit = require('modules/settings/templates/partials/subscription/plan-edit.hbs');

var SubscriptionPlanView = ItemView.extend({
    getTemplate: function(){
        return this.getOption('mode') === 'edit' ? templateEdit : templateDisplay;
    },

    className: function() {
        return this.getOption('mode') === 'edit' ? 'subscription-plan-edit' : 'subscription-plan-display';
    },

    ui: {
        form: 'form',
        editButton: '[data-action="edit"]',
        saveButton: '[type="submit"]',
        billingIntervalRadio: '[name="subscription-billing-interval"]',
        planRadio: '[name="subscription-plan"]',
        switchPlanHint: '.switch-plan-info',
        buttonVoucher: '.btn[data-action="enter-voucher"]',
    },

    events: {
        'submit @ui.form': 'onSubmit',
        'click @ui.editButton': 'openEditModal',
        'change @ui.billingIntervalRadio': 'switchPlan',
        'change @ui.planRadio': 'switchPlan',
        'click @ui.buttonVoucher': 'onOpenVoucherModal',
    },

    isSetup: false,

    mode: 'display',

    viewData: {
        selectedPlan: function() {
            return this.model.get('selectedPlan'); //customAttributes are not yet populatet into template item
        },
        activePlan: function() {
            return this.model.get('activePlan'); //customAttributes are not yet populatet into template item
        },
        willSwitchPlan: function() {
            return this.model.get('willSwitchPlan'); //customAttributes are not yet populatet into template item
        },
        countryCollection: function() {
            return App.radio().request('countries:collection');
        },
    },

    initialize: function(options) {
        ItemView.prototype.initialize.apply(this, arguments);

        this.listenTo(App.radio('subscription:setup').vent, 'change:plan', this.openEditModal.bind(this))
    },

    onShow: function() {
        if (this.getOption('mode') === 'edit') {
            this.triggerMethod('revokeReadyToSave');
            this.switchPlan();
        }
    },

    onSubmit: function(event) {
        if (event) {
            event.preventDefault();
        }

        // Show loading
        this.triggerMethod('saving');

        this.model.save(this.getData(), {
            patch: true,
            wait: true,
            success: function() {
                this.triggerMethod('saved', this.getData());
            }.bind(this),
            error: function(model, response) {
                this.triggerMethod('save:error', response);
            }.bind(this),
        });
    },

    onSaving: function() {
        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', true).addClass('is-loading');
        }
    },

    getData: function() {
        var selectedPlanId = this.$('[name="subscription-plan"]:checked').val();

        var data = {
            setupStep: this.getOption('isSetup') ? this.model.get('setupStep') + 1 : this.model.get('setupStep'),
            billingInterval: this.$('[name="subscription-billing-interval"]:checked').val(), //@todo check if we should adapt this to upcomingBillingInterval
            plans: _.map(this.model.get('plans'), function(plan) {
                return {id: plan.id, selected: plan.id === selectedPlanId};
            }),
        };

        return data;
    },

    openEditModal: function(event) {
        App.addModal(new SubscriptionModalLayout({
            title: App.t('subscription::setup:plans'),
            bodyView: new SubscriptionPlanView({
                mode: 'edit',
                model: this.model,
            }),
        }), {
            additionalClassName: 'modal-subscription ' + (this.getOption('isSetup') ? 'modal-subscription-setup' : ''),
        });
    },

    onSaveError: function(response) {
        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', false).removeClass('is-loading');
        }
    },

    switchPlan: function(event) {
        if (this.model.get('subscriptionActive') === false) {
            if (this.isValid()) {
                this.triggerMethod('readyToSave');
            } else {
                this.triggerMethod('revokeReadyToSave');
            }

            return; //only show switch info if setup was completed before
        }

        var chosenBillingInterval = this.$('[name="subscription-billing-interval"]:checked').val();
        var chosenPlanId = this.$('[name="subscription-plan"]:checked').val();
        var chosenPlan = _.findWhere(this.model.get('plans'), {id: chosenPlanId});

        var activeBillingInterval = this.model.get('currentBillingInterval');
        var activePlan = this.model.get('activePlan');
        var upcomingPlan = this.model.get('selectedPlan');
        var upcomingBillingInterval = this.model.get('upcomingBillingInterval');

        var activeCombo = activePlan.id === 'basic' ? 'basic' : activePlan.id + '-' + activeBillingInterval;
        var chosenCombo = chosenPlan.id === 'basic' ? 'basic' : chosenPlan.id + '-' + chosenBillingInterval;
        var upcomingCombo = upcomingPlan.id === 'basic' ? 'basic' : upcomingPlan.id + '-' + upcomingBillingInterval;

        if (activeCombo !== chosenCombo) {
            this.ui.switchPlanHint.html(this.switchMatrix(activePlan, activeCombo, chosenPlan, chosenCombo));
            var amountToPay = chosenPlan['amount' + _.ucfirst(chosenBillingInterval) + 'Total'] - this.model.get('currentSubscriptionValue');

            if (amountToPay > 0) {
                var labelPay = Html.icon('lock') + App.t('subscription::setup:button:upgrade-amount', {
                    amount: amountToPay,
                    currency: this.model.get('currency'),
                });
                this.triggerMethod('readyToSave', {saveButtonLabel: labelPay, hasToPay: true});
            } else {
                this.triggerMethod('readyToSave', {saveButtonLabel: App.t('subscription::setup:button:switch-plan')});
            }
        } else {
            if (activeCombo !== upcomingCombo) {
                this.ui.switchPlanHint.empty();
                this.triggerMethod('readyToSave');
            } else {
                this.ui.switchPlanHint.empty();
                this.triggerMethod('revokeReadyToSave');
            }
        }
    },

    switchMatrix: function(activePlan, activeCombo, chosenPlan, chosenCombo) {
        var currency = this.model.get('currency');

        return App.t('subscription::plan:text:switch:from:' + activeCombo + ':to:' + chosenCombo, {
            chosenPlanName: chosenPlan.name,
            chosenPlanAmountMonthly: Html.formatCurrency(chosenPlan.amountMonthlyTotal, currency),
            chosenPlanAmountAnnually: Html.formatCurrency(chosenPlan.amountAnnuallyTotal, currency),
            activePlanName: activePlan.name,
            activePlanValidUntil: Html.formatDate(activePlan.validUntil, App.user.get('languageIso')),
            accountBalance: Html.formatCurrency(this.model.get('currentSubscriptionValue'), currency),
        });
    },

    validate: function() {
        var data = this.getData();
        var validationErrors = {};

        if (this.model.get('subscriptionActive') === false) {
            if (_.findWhere(data.plans, {selected: true}).id === 'basic') {
                validationErrors.selectedPlanInvalid = App.t('subscription::setup:choose-a-plan:plan:select-paid');
            }
        }

        return validationErrors;
    },

    isValid: function() {
        var validationErrors = this.validate();

        return _.isEmpty(validationErrors);
    },

    onReadyToSave: function(data) {
        var hasToPay = !!(data && data.hasToPay); //toggleClass needs a true boolean
        var saveButtonLabel = data && data.saveButtonLabel ? data.saveButtonLabel : App.t('subscription::setup:save:button');
        this.ui.saveButton.html(saveButtonLabel).toggleClass('is-pay', hasToPay);
        this.ui.saveButton.prop('disabled', false).removeClass('is-loading');
    },

    onRevokeReadyToSave: function(data) {
        var hasToPay = !!(data && data.hasToPay);
        var saveButtonLabel = data && data.saveButtonLabel ? data.saveButtonLabel : App.t('subscription::setup:save:button');
        this.ui.saveButton.html(saveButtonLabel).toggleClass('is-pay', hasToPay);
        this.ui.saveButton.prop('disabled', true);
    },

    /**
     * Is triggered, when the voucher code modal should be opened
     */
    onOpenVoucherModal: function() {
        var voucherModal = new VoucherModalView({model: this.model});
        App.addModal(voucherModal, {
            additionalClassName: 'modal-center',
            additionalBgClassName: 'light-bg',
        });
    },

});

module.exports = SubscriptionPlanView;